// LAP-550 — État vide centré et stylisé
import React from 'react'
import { Box, Stack } from '@mui/material'
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined'

export default function EmptyState({ label, icon }) {
  return (
    <Stack
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{ color: 'rgba(255,255,255,0.55)', textAlign: 'center', px: 2 }}
    >
      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon || <InboxOutlinedIcon sx={{ fontSize: 22, opacity: 0.6 }} />}
      </Box>
      <Box sx={{ fontSize: 13, maxWidth: 240 }}>{label}</Box>
    </Stack>
  )
}
